<template>
  <div class="select">
    <select
      :id="`${field.name}-field`"
      :name="field.name"
    >
      <option>Select One</option>
      <option v-for="(option, index) in field.options" :key="index" :value="option">
        {{ option }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  props: {
    field: {
      type: Object,
      required: true,
    },
  },
};
</script>
